import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCommunicationPreferences,
    updateCommunicationPreferences,
} from 'lib/actions';
import {
    getCommsPreferences,
    getCommsPreferencesIsFetching,
    getCommsPreferencesError,
    getCommsPreferencesIsPosting,
    getCommsPreferencesPostError,
} from 'lib/selectors';

type CommsPrefs = Record<string, boolean>;

const FAILURE_TYPE = 'UPDATE_COMMUNICATION_PEFERENCES_FAILURE';

const useCommunicationPreferences = () => {
    const dispatch = useDispatch();
    const commsPreferences = useSelector(getCommsPreferences) as CommsPrefs;
    const isFetching = useSelector(getCommsPreferencesIsFetching);
    const error = useSelector(getCommsPreferencesError);
    const postError = useSelector(getCommsPreferencesPostError);
    const isPosting = useSelector(getCommsPreferencesIsPosting);
    const [comms, setComms] = useState<CommsPrefs>({});

    useEffect(() => {
        dispatch(fetchCommunicationPreferences());
    }, [dispatch]);

    useEffect(() => {
        if (commsPreferences) {
            setComms(commsPreferences);
        }
    }, [commsPreferences]);

    const updateValue = (name: string, value: boolean): CommsPrefs => ({
        ...comms,
        [name]: value,
    });

    const handleSwitchClick = (name: string, value: boolean) => {
        if (isPosting) return;
        const updatedState = updateValue(name, value);
        setComms(updatedState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (dispatch(updateCommunicationPreferences(updatedState)) as any).then(
            (state: { type?: string } | undefined) => {
                if (state?.type === FAILURE_TYPE) {
                    setComms(updateValue(name, !value));
                }
            },
        );
    };

    return {
        comms,
        isFetching,
        error,
        postError,
        handleSwitchClick,
    };
};

export default useCommunicationPreferences;
